import { mapGetters } from "vuex";
export default {
  data: () => ({
    pay_form: null,
    amount: 9000,
    payment: 123213,
    user:{
      phone: null,
      email: null,
    },
    settings: {
			priceMonth1:null,
			priceMonth3:null,
			priceMonth6:null,
			priceYear:null,
		}

  }),

  mounted () {
    this.$axios.get(`order/tariff`).then(({data}) => {
			this.settings.priceMonth1 = data.result.find(item => item.key == '1M').meta.cost
			this.settings.priceMonth3 = data.result.find(item => item.key == '3M').meta.cost
			this.settings.priceMonth6 = data.result.find(item => item.key == '6M').meta.cost
			this.settings.priceYear = data.result.find(item => item.key == '12M').meta.cost
    })
  },
  watch :{
    getUser(to, from) {
      this.user.email = to.email;
      this.user.phone = to.phone;
    },
  },
  methods: {
    pay(amount) {
      if(this.user.phone) {
        this.$axios.post(`order/tariff`, {
          amount: amount,
        }).then(res => {
          this.$root.$emit('modal.pay', {uuid: res.data.result.uuid});
        })
      } else {
        this.$root.$emit('modal.auth');
      }
    },
  },
  computed: {
    ...mapGetters(['getUser'])
  },
}



// WEBPACK FOOTER //
// ./src/pages/Rate/rate.js